import { GUID, Param, Address } from "app/brightserve/brightserve.module";

export class Client {
    Id: GUID;
    Code: string;
    Name: string;
    Status: Param;
    
    DateCreated: Date;
    DateModified: Date;
    DateAccessed: Date;

    AtSeaEmail: string;
    AtSeaMobile: string;
    AtSeaPhone: string;
    AtSeaVOIP: string;

    ManagementAddress: Address;
    ManagementEmail: string;
    ManagementPhone: string;
    ManagementMobile: string;

    ContractStartDate: Date;
    ContractEndDate: Date;
    ContractStatus: Param;

    HeliPad: boolean;
    MedicalProfessionalOnBoard: boolean;
    SickBay: boolean;

    VesselLength: Param;
    VesselName: string;
    VesselPurpose: Param;

    SyncId: GUID;
    NewSyncId: string;

    constructor(init?: Partial<Client>) {
        Object.assign(this, init);

        if (init && init.Status) {
            this.Status = new Param(init.Status);
        } else {
            this.Status = null;
        };

        if (init && init.ManagementAddress) {
            this.ManagementAddress = new Address(init.ManagementAddress);
        } else {
            this.ManagementAddress = null;
        };

        if (init && init.ContractStatus) {
            this.ContractStatus = new Param(init.ContractStatus);
        } else {
            this.ContractStatus = null;
        };

        if (init && init.VesselLength) {
            this.VesselLength = new Param(init.VesselLength);
        } else {
            this.VesselLength = null;
        };

        if (init && init.VesselPurpose) {
            this.VesselPurpose = new Param(init.VesselPurpose);
        } else {
            this.VesselPurpose = null;
        };
    };

    static NewClient(init?): any {
        var client = new Client(init);
        client.Id = GUID.newGuid();
        client.DateCreated = new Date();

        client.ContractStartDate = null;
        client.ContractEndDate = null;
        return client;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/client.ts